<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <div>
      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start my-1 my-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="questions"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >
          <!-- Column: edit -->
          <template #cell(edit)="data">
            <div v-b-modal.modal-edit class="text-primary" @click="selectedQuestion = JSON.parse(JSON.stringify(data.item))">
              <feather-icon size="20" icon="Edit2Icon"/>
            </div>
          </template>
          
          <!-- Column: delete -->
<!--          <template #cell(delete)="data">-->
<!--            <b-link class="text-danger"-->
<!--                    v-b-modal.modal-delete-->
<!--                    @click="showModal(data.item.productCommentId)"-->
<!--            >-->
<!--              <feather-icon size="20" icon="TrashIcon" />-->
<!--            </b-link>-->
<!--          </template>-->
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCounts"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon style="transform: rotate(180deg)"
                                icon="ChevronLeftIcon"
                                size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    
<!--    <b-modal-->
<!--        id="modal-delete"-->
<!--        centered-->
<!--        ok-title="حذف"-->
<!--        cancelTitle="انصراف"-->
<!--        @ok="deleteComment(deleteItem)"-->
<!--    >-->
<!--      <span>حذف شود؟</span>-->
<!--    </b-modal>-->

    <b-modal
        v-if="selectedQuestion"
        id="modal-edit"
        centered
        title="ثبت پاسخ برای دیدگاه کاربر"
        ok-only
        ok-title="ثبت"
        @ok="editQuestion"
    >
      <b-form-group
          label="پاسخ شما :"
          label-for="name-input"
      >
        <b-form-input
            id="name-input"
            v-model="selectedQuestion.title"
            required
        />
      </b-form-group>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BLink, BPagination, BOverlay, BModal, BFormGroup, BFormCheckbox
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Helper from "@/libs/Helper";
import {ProductCommentDeleteRequest} from "@/libs/Api/Product";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {QuestionEdit, QuestionGetAllByTitle} from "@/libs/Api/Question";

export default {
  title:"لیست سوالات - پنل ادمین ذهن آرایی",
  name: "QuestionList",
  data(){
    return{
      questions:null,
      showOverlay:false,
      testId:this.$route.params.id,
      testTitle:this.$route.params.title,
      currentPage:1,
      totalCounts:null,
      IsSelectedForMainPage:false,
      perPage:10,
      myTableColumns : [
        { key: 'id' ,label :'شناسه'},
        { key: 'testTitle' ,label :'نام تست'},
        { key: 'title' ,label :'متن سوال'},
        { key: 'edit',label:'ویرایش'},
        // { key: 'delete',label:'حذف'},
      ],
      deleteItem:null,
      perPageOptions:[10, 20, 30 , 40 , 50],
      commentMessage: '',
      selectedQuestion: null,
      selectedCommentProductId: null,
      searchCommand:'',
    }
  },
  async created() {
    await this.getQuestions()
  },
  methods:{
    async getQuestions(){
      let _this = this;
      _this.showOverlay = true;

      let data = {
        pageNumber:_this.currentPage,
        count:_this.perPage,
        testTitle:_this.testTitle
      }

      let questionGetAllByTitle = new QuestionGetAllByTitle(_this);
      questionGetAllByTitle.setParams(data);
      await questionGetAllByTitle.fetch(function (content){
        _this.showOverlay = false;
        _this.questions = content.data
        _this.totalCounts = content.total;
      },function (error){
        _this.showOverlay = false;
      })
    },
    async editQuestion() {
      let _this = this;
      _this.showOverlay = true;

      _this.selectedQuestion['psychologicalTestId'] = _this.testId;

      let questionEdit = new QuestionEdit(_this);
      questionEdit.setParams(_this.selectedQuestion);
      await questionEdit.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            // text: `پاسخ شما ثبت شد.`,
          },
        })
        _this.selectedQuestion = null;
        _this.getQuestions();
      }, function () {
        _this.showOverlay = false;
      });
    },
    async deleteComment(param){
      let _this = this;
      _this.showOverlay = true;

      let productCommentDeleteRequest = new ProductCommentDeleteRequest(_this);
      productCommentDeleteRequest.setId(param);
      await productCommentDeleteRequest.fetch(function (content){
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `حذف شد.`,
          },
        })
        _this.getQuestions()
      },function (error){
        _this.showOverlay = false;
      })
    },
    createJalaliDate(param){
      return new Date(param).toLocaleDateString("fa-IR",);
    },
    makePrettyPrice(param){
      return Helper.prettyPrice(param,0)
    },
    showModal(param){
      let _this = this;
      _this.deleteItem = param
    },
  },
  watch:{
    perPage:function (nv,ov){
      this.getQuestions();
    },
    currentPage:function (nv,ov) {
      this.getQuestions();
    },
  },
  components: {
    BFormCheckbox,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BLink,
    BPagination,
    BOverlay,
    BModal,
    vSelect,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
